import { randomString } from './StringUtils';
export function provideId() {
  const secondsSinceUnixEpoch = Math.floor(new Date().getTime() / 1000);
  return secondsSinceUnixEpoch.toString(36) + randomString();
}